export const SEND_AI_PROCESS_RESULTS_TAG_FIELDS = [
  { key: 'postedTagId', testIdKey: 'posted-tag', label: 'When the results are posted' },
  { key: 'failedTagId', testIdKey: 'failed-tag', label: 'When the delivery fails' },
];

export const SEND_AI_PROCESS_RESULTS_TAGS_TITLE = 'Add a tag to the loan';

export const NO_DELIVERY_CONNECTOR_TEXT =
  'No connector that can deliver results is set up. Set one up in Integration Studio.';
